import { render, staticRenderFns } from "./HintsItem.vue?vue&type=template&id=04ed2b38&scoped=true"
import script from "./HintsItem.vue?vue&type=script&lang=js"
export * from "./HintsItem.vue?vue&type=script&lang=js"
import style0 from "./HintsItem.vue?vue&type=style&index=0&id=04ed2b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed2b38",
  null
  
)

export default component.exports